import { Component } from '@angular/core';

@Component({
    selector: 'app-bank-account-create',
    templateUrl: './bank-account-create.component.html',
    styleUrls: ['./bank-account-create.component.scss'],
    standalone: false
})
export class BankAccountCreateComponent {}
